(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
function initializeDeferredProductGallery(scope) {
  scope.querySelectorAll('[data-product-section] .product-gallery').forEach(gallery => {
    const holders = [...gallery.querySelectorAll('[data-gallery-deferred]')].filter(holder => !holder.dataset.galleryObserved);
    const reveal = holder => {
      const template = holder.querySelector('template[data-gallery-image]');
      if (!template) return;
      holder.appendChild(template.content.cloneNode(true));
      template.remove();
    };
    if (!('IntersectionObserver' in window)) { holders.forEach(reveal); return; }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { root: gallery, rootMargin: '250px', threshold: 0.01 });
    holders.forEach(holder => { holder.dataset.galleryObserved = 'true'; observer.observe(holder); });
  });
}
initializeDeferredProductGallery(document);
document.addEventListener('shopify:section:load', event => initializeDeferredProductGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 const trigger=event.target.closest('[data-review-photo]');
 if(!trigger)return;
 const dialog=trigger.closest('[data-product-sidebar]').querySelector('.aurelia-photo-dialog');
 if(!dialog)return;
 const image=dialog.querySelector('.aurelia-photo-expanded');
 image.src=trigger.dataset.reviewPhoto;
 image.alt=trigger.dataset.photoAlt||'';
 dialog.showModal();
 const closeButton=dialog.querySelector('.aurelia-photo-close');
 closeButton.onclick=()=>dialog.close();
 dialog.onclick=click=>{if(click.target===dialog)dialog.close();};
 dialog.onclose=()=>trigger.focus({preventScroll:true});
 closeButton.focus();
});
function placeProductReviewCards(event){
 const details=document.querySelector('[data-product-section] .product-details');
 if(!details)return;
 const scope=event?.target instanceof HTMLElement?event.target:document;
 const cardsList=[...scope.querySelectorAll('[data-product-sidebar]')];
 cardsList.forEach(cards=>{
  const id=cards.dataset.reviewSection;
  document.querySelectorAll('[data-product-sidebar]').forEach(old=>{if(old!==cards&&old.dataset.reviewSection===id)old.remove();});
  const owner=cards.closest('.shopify-section');
  if(owner&&!owner.contains(details)&&owner.parentElement!==details)details.append(owner);
 });
}
placeProductReviewCards();
document.addEventListener('shopify:section:load',placeProductReviewCards);
document.addEventListener('shopify:section:unload',event=>{
 const id=event.detail?.sectionId;
 if(!id)return;
 document.querySelectorAll('[data-product-sidebar]').forEach(cards=>{if(cards.dataset.reviewSection===id&&!event.target.contains(cards))cards.remove();});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('siennas-trust-caption')){
customElements.define('siennas-trust-caption',class extends HTMLElement{
connectedCallback(){
if(this.observer||this.classList.contains('is-visible')||!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
this.classList.add('is-waiting');
this.observer=new IntersectionObserver(entries=>{
if(entries.some(entry=>entry.isIntersecting)){this.classList.remove('is-waiting');this.classList.add('is-visible');this.observer.disconnect();}
},{threshold:.25});
this.observer.observe(this);
}
disconnectedCallback(){this.observer?.disconnect();this.observer=null;}
});
}

  } catch(e) { console.error(e); }
})();
})();
